import type { SVGProps } from 'react';

const SvgMinusCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36" {...props}>
    <path fill={props.color} d="M18 0a18 18 0 1 0 18 18A18 18 0 0 0 18 0m8.93 19h-18v-2h18Z" />
  </svg>
);

export default SvgMinusCircle;
